import { SortInput } from 'components/Table'
import { WorkspaceSortBy } from './types'

export const DEFAULT_SORT: SortInput<WorkspaceSortBy> = {
  by: 'name',
  direction: 'asc',
} as const

export const SORTABLE_COLUMNS: WorkspaceSortBy[] = ['crmId', 'name', 'updatedAt']
